/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

import type { ApiCountryFooterLinksListParams } from './model/apiCountryFooterLinksListParams';
import type { PaginatedCountryFooterLinkList } from './model/paginatedCountryFooterLinkList';

/**
 * Sets reasonable pagination defaults for all the API list views.
 */
export const apiCountryFooterLinksList = (
  params?: ApiCountryFooterLinksListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedCountryFooterLinkList>({
    url: `/api/v7/frontend/country-footer-links/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getApiCountryFooterLinksListQueryKey = (params?: ApiCountryFooterLinksListParams) => {
  return [`/api/v7/frontend/country-footer-links/`, ...(params ? [params] : [])] as const;
};

export const getApiCountryFooterLinksListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiCountryFooterLinksList>>,
  TError = ErrorType<unknown>
>(
  params?: ApiCountryFooterLinksListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiCountryFooterLinksList>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiCountryFooterLinksListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiCountryFooterLinksList>>> = ({
    signal,
  }) => apiCountryFooterLinksList(params, signal);

  return {
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof apiCountryFooterLinksList>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type ApiCountryFooterLinksListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiCountryFooterLinksList>>
>;
export type ApiCountryFooterLinksListQueryError = ErrorType<unknown>;

export function useApiCountryFooterLinksList<
  TData = Awaited<ReturnType<typeof apiCountryFooterLinksList>>,
  TError = ErrorType<unknown>
>(
  params?: ApiCountryFooterLinksListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiCountryFooterLinksList>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiCountryFooterLinksListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
